import { SearchQuery, EntityItem } from '../../../types';
import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { branchesApi } from '@texas/api/endpoints/branchesApi';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export async function searchBranch(query: SearchQuery): Promise<EntityItem[]> {
  const response = await branchesApi.filterBranchesForChat({
    query: query.query,
    filters: {},
  });

  if (response.hasError) {
    return [];
  }

  return response.data.map((c) => ({
    id: c.id,
    name: c.name,
    tag: c.tag,
    type: ChatMessageEntityLinkType.Branch,
    identifier: randomIdentifier(),
  }));
}
